import { TEMPLATE_TYPE } from './constants';

export const today = () => {
  const date = new Date();

  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = String(date.getFullYear());

  return `${yyyy}-${mm}-${dd}`;
}

export const buttonSecondaryLabelOptions = [
  {
    id: 'NON ORA',
    description: 'NON ORA'
  },
  {
    id: 'CHIUDI',
    description: 'CHIUDI'
  }
];

export const labelMap = {
    triggerTimelineTemplateId: 'Seleziona template:',
    title: 'Titolo (max 75 caratteri - consentiti solo tag <b></b> e <br>) (*):',
    img: 'Immagine (consigliate 1680x750px - max 500KB):',
    icon: 'Icona (altezza max 100px):',
    text: 'Testo (consigliati max 150 caratteri - consentiti solo tag <b></b> e <br>)(*):',
    linkLabel: 'Testo del link:',
    linkUrl: 'Url del link (accetta solo link con prefisso http:// o https://.):',
    priority: 'Priorità (max 100)',
    expiringCampaignDate: 'Scadenza campagna (*):',
    persistenceNotificationDate: 'Durata notifica (*):',
    primaryCTAtype: 'Tipo di CTA primaria:',
    buttonDeeplinkingLabel: 'CTA primaria:',
    buttonDeeplinkingOption: 'Azione primaria:',
    buttonActionLabel: 'CTA primaria:',
    buttonActionOption: 'Azione primaria:',
    buttonSecondaryLabel: 'CTA secondaria (*)',
    buttonSecondaryAction: 'Azione secondaria (*)',
    buttonSecondaryProductType: 'Tipo di prodotto CTA secondaria:',
    titlePush: 'Titolo (max 75 caratteri - tag html non consentiti):',
    imagePush: 'Immagine:',
    iconPush: 'Icona:',
    textPush: 'Testo (consigliati max 150 caratteri - tag html non consentiti)(*):',
    actionPush: 'Azione:',
    actionPushProducyType: 'Tipo di prodotto:',
    titleBanner: 'Titolo (max 20 caratteri): (*)',
    textBanner: 'Testo (consigliati max 65 caratteri - Non sono consentiti altri tag al di fuori del testo): (*)',
    linkImageBannner: 'Link Immagine:',
    startCampaignDate: 'Inizio campagna (*):',
    endCampaignDate: 'Fine campagna (*):',
    imageBanner:'Link Immagine:',
    expiringCampaignDateBanner: 'Fine campagna (*):',
    backgroundColor: 'Gradiente sfondo:',
    sizeBox: 'Dimensione del box:',
    templateLogicType: 'Tipologia della card:',
    closable: 'Inserire icona di chiusura',
    consentC3: 'C3',
    target: 'Scegli in che box vuoi inserire il tuo promo banner: (*))',
    priorityBanner: 'Assegna una priorità alla tua promo banner da 5 a 1: (*)',
    enabledAppNames: 'Scegliere i canali sui quali vuoi inviare la TTL (*):',
    bannerChannelChoiceLabel: 'Scegliere i canali sui quali vuoi inviare il tuo banner (*):',
    previewTitle: 'Titolo Preview (max 20 caratteri) (*):',
    previewImg: 'Link Immagine Preview (consigliate 350x156px) (*):',
    previewText: 'Testo Preview (consigliato max 65 caratteri - Non sono consentiti altri tag al di fuori del testo) (*):'
}

export const fromResponseToState = (res) => {
  console.log('res', res);
  let stateObject = {};
  if (res && res.templateType && res.templateType.includes('TTL')) {

    Object.entries(res).forEach(([key, value]) => {
      if (key === 'link') {
        stateObject.linkLabel = value.label;
        stateObject.linkUrl = value.path;
      } else if (key === 'buttons') {
        const buttonTypeTemp = value.primaryButton && value.primaryButton.deepLinking && value.primaryButton.deepLinking.id ? value.primaryButton.deepLinking.id : '';
        const buttonType = buttonTypeTemp.split('_')[0];

        if (buttonType === 'DL') {
          stateObject.primaryCTAtype = 'DL';
          stateObject.buttonDeeplinkingLabel = value.primaryButton && value.primaryButton.label ? value.primaryButton.label : '';
          stateObject.buttonDeeplinkingOption = value.primaryButton && value.primaryButton.deepLinking && value.primaryButton.deepLinking.id ? value.primaryButton.deepLinking.id : '';
        } else if (buttonType === 'ACTION') {
          stateObject.primaryCTAtype = 'ACTION';
          stateObject.buttonActionLabel = value.primaryButton && value.primaryButton.label ? value.primaryButton.label : '';
          stateObject.buttonActionOption = value.primaryButton && value.primaryButton.deepLinking && value.primaryButton.deepLinking.id ? value.primaryButton.deepLinking.id : '';
        }
        stateObject.buttonSecondaryLabel = value.secondaryButton && value.secondaryButton.label ? value.secondaryButton.label : '';
        stateObject.buttonSecondaryAction = value.secondaryButton && value.secondaryButton.deepLinking && value.secondaryButton.deepLinking.id ? value.secondaryButton.deepLinking.id : '';
        stateObject.buttonSecondaryProductType = value.secondaryButton && value.secondaryButton.deepLinking && value.secondaryButton.deepLinking.idProductType ? value.secondaryButton.deepLinking.idProductType : '';
      } else if (key === 'enabledAppNames') {
        stateObject.enabledAppNames = value;
      } else if (key === 'previewTitle') {
        stateObject.previewTitle = value;
      } else if (key === 'previewText') {
        stateObject.previewText = value;
      } else if (key === 'previewImg') {
        stateObject.previewImg = value;
      } else if (key === 'expiringCampaignDate') {
        stateObject.endCampaignDate = value;
      } else if (key === 'backgroundColor') {
        stateObject.ttlBackgroundColor = value;
      } else {
        key === 'priority' ? stateObject[key] = parseInt(value) : stateObject[key] = value;
      }
    });
  } else if (res && res.templateType && res.templateType.includes('BANNER')) {
    stateObject.sizeBox = 'medium';
    Object.entries(res).forEach(([key, value]) => {
      if (key === 'title') {
        stateObject.titleBanner = value;
      } else if (key === 'link'){
        if(value && value.label && value.label.trim() !== '' && value.path && value.path.trim() !== ''){
          stateObject.primaryCTAtype = 'EXT_LINK';
        }
        stateObject.linkLabel = value.label;
        stateObject.linkUrl = value.path;
      } else if (key === 'buttons') {
        const buttonTypeTemp = value.primaryButton && value.primaryButton.deepLinking && value.primaryButton.deepLinking.id ? value.primaryButton.deepLinking.id : '';
        const buttonType = buttonTypeTemp.split('_')[0];

        if (buttonType === 'DL') {
          stateObject.primaryCTAtype = 'DL';
          stateObject.buttonDeeplinkingLabel = value.primaryButton && value.primaryButton.label ? value.primaryButton.label : '';
          stateObject.buttonDeeplinkingOption = value.primaryButton && value.primaryButton.deepLinking && value.primaryButton.deepLinking.id ? value.primaryButton.deepLinking.id : '';
        } else if (buttonType === 'ACTION') {
          stateObject.primaryCTAtype = 'ACTION';
          stateObject.buttonActionLabel = value.primaryButton && value.primaryButton.label ? value.primaryButton.label : '';
          stateObject.buttonActionOption = value.primaryButton && value.primaryButton.deepLinking && value.primaryButton.deepLinking.id ? value.primaryButton.deepLinking.id : '';
        }
        stateObject.buttonSecondaryLabel = value.secondaryButton && value.secondaryButton.label ? value.secondaryButton.label : '';
        stateObject.buttonSecondaryAction = value.secondaryButton && value.secondaryButton.deepLinking && value.secondaryButton.deepLinking.id ? value.secondaryButton.deepLinking.id : '';
        stateObject.buttonSecondaryProductType = value.secondaryButton && value.secondaryButton.deepLinking && value.secondaryButton.deepLinking.idProductType ? value.secondaryButton.deepLinking.idProductType : '';
      } else if (key === 'priority') {
        stateObject.priorityBanner = parseInt(value);
      } else if (key === 'text') {
        stateObject.textBanner = value;
      } else if (key === 'expiringCampaignDate') {
        stateObject.endCampaignDate = value;
      } else if (key === 'img') {
        stateObject.imageBanner = value;
      } else if (key === 'enabledAppNames') {
        stateObject.bannerChannelChoiceLabel = value;
      } else {
        stateObject[key] = value;
      }
    });
  } else {
    Object.entries(res).forEach(([key, value]) => {
      if (key === 'pushAction') {
        stateObject.actionPush = value.id;
        stateObject.actionPushProducyType = value.idProductType;
      } else if (key === 'title') {
        stateObject.titlePush = value;
      } else if (key === 'text') {
        stateObject.textPush = value;
      } else if (key === 'img') {
        stateObject.imagePush = value;
      } else {
        stateObject[key] = value;
      }
    });
  }

  return stateObject;
}

export const fromStateToRequest = (state) => {
  console.warn('fromStateToRequest', state);
  let reqObject = {};

  let link = {};
  let buttons = {
    primaryButton: {
      deepLinking: {}
    },
    secondaryButton: {
      deepLinking: {}
    }
  };
  let pushAction = {};
  let title = '';
  let text = '';
  let img = '';
  let expiringCampaignDate = '';
  let priority = '';
  let previewTitle = '';
  let previewText = '';
  let previewImg = '';
  let backgroundColor = '';
  let enabledAppNames = '';

  Object.entries(state).forEach(([key, value]) => {
    switch (key) {
      case 'linkLabel':
        link.label = value;
        break;
      case 'linkUrl':
        link.path = value;
        break;
      case 'buttonDeeplinkingLabel':
        if (state.primaryCTAtype === 'DL') buttons.primaryButton.label = value;
        break;
      case 'buttonActionLabel':
        if (state.primaryCTAtype === 'ACTION') buttons.primaryButton.label = value;
        break;
      case 'buttonDeeplinkingOption':
        if (state.primaryCTAtype === 'DL') buttons.primaryButton.deepLinking.id = value;
        break;
      case 'buttonActionOption':
        if (state.primaryCTAtype === 'ACTION') buttons.primaryButton.deepLinking.id = value;
        break;
      case 'buttonSecondaryLabel':
        if(reqObject.templateType !== TEMPLATE_TYPE.BANNER) {
          return buttons.secondaryButton.label = buttonSecondaryLabelOptions.find(o => o.id === value).description;
        }
        break;
      case 'buttonSecondaryAction':
        if(reqObject.templateType !== TEMPLATE_TYPE.BANNER) {
          return buttons.secondaryButton.deepLinking.id = value;
        }
        break;
      case 'buttonSecondaryProductType':
        if(reqObject.templateType !== TEMPLATE_TYPE.BANNER) {
          return buttons.secondaryButton.deepLinking.idProductType = value;
        }
        break;
      case 'actionPush':
        pushAction.id = value;
        break;
      case 'actionPushProducyType':
        pushAction.idProductType = value;
        break;
      case 'titlePush':
        title = value;
        break;
      case 'textPush':
        text = value;
        break;
      case 'imagePush':
        img = value;
        break;
      case 'priority':
        reqObject[key] = parseInt(value);
        break;
      case 'primaryCTAtype':
        // ALL unnecessary BE params are not set to payload
        break;
      case 'titleBanner':
        if(reqObject.templateType === TEMPLATE_TYPE.BANNER) {
          return title = value;
        }
        break;
      case 'textBanner':
        if(reqObject.templateType === TEMPLATE_TYPE.BANNER) {
          return text = value;
        }
        break;
      case 'endCampaignDate':
        if(reqObject.templateType === TEMPLATE_TYPE.BANNER || reqObject.templateType === TEMPLATE_TYPE.TTL) {
          return expiringCampaignDate = value;
        }
        break;
      case 'imageBanner':
        if(reqObject.templateType === TEMPLATE_TYPE.BANNER) {
          return img = value;
        }
        break;
      case 'priorityBanner':
        if(reqObject.templateType === TEMPLATE_TYPE.BANNER) {
          priority = parseInt(value);
        }
        break;
      case 'bannerChannelChoiceLabel':
        if(reqObject.templateType === TEMPLATE_TYPE.BANNER) {
          return enabledAppNames = value;
        }
        break;
      case 'previewTitle':
        if(reqObject.templateType === TEMPLATE_TYPE.TTL) {
          return previewTitle = value;
        }
        break;
      case 'previewText':
        if(reqObject.templateType === TEMPLATE_TYPE.TTL) {
          return previewText = value;
        }
        break;
      case 'previewImg':
        if(reqObject.templateType === TEMPLATE_TYPE.TTL) {
          return previewImg = value;
        }
        break;
      case 'ttlBackgroundColor':
        if(reqObject.templateType === TEMPLATE_TYPE.TTL) {
          return backgroundColor = value;
        }
        break;
      default:
        reqObject[key] = value;
        break;
    }
  });

  if (reqObject.templateType.includes('TTL')) {
    reqObject = { ...reqObject, link, buttons, expiringCampaignDate, previewTitle, previewText, previewImg, backgroundColor };
  } else if(reqObject.templateType.includes('BANNER')) {
    reqObject = { ...reqObject, pushAction, title, text, img, link, buttons, expiringCampaignDate, priority, enabledAppNames};
  } else {
    reqObject = { ...reqObject, pushAction, title, text, img };
  }
  return reqObject;
}

function removeCustomAlert() {
  document.body.style.height = '100%';
  document.body.style.minHeight = '100%';
  document.body.style.overflow = 'auto';

  document.getElementsByTagName('body')[0].removeChild(document.querySelector('.modal-container'));
}

export const createCustomAlert = (title, txt, label, action, closeButton = false, closeLabel = 'CHIUDI') => {

  document.body.style.height = '100vh';
  document.body.style.minHeight = '100vh';
  document.body.style.overflow = 'hidden';

  const d = document;
  let mObj;
  let alertObj;
  let h1;
  let container;
  let msg;
  let btn;
  let btnClose;

  if(d.querySelector('.modal-container')) return;

  mObj = d.getElementsByTagName('body')[0].appendChild(d.createElement('div'));
  mObj.classList.add('modal-container');

  alertObj = mObj.appendChild(d.createElement('div'));
  alertObj.classList.add('alert-box');
  if(d.all && !window.opera) alertObj.style.top = document.documentElement.scrollTop + 'px';
  alertObj.style.left = (d.documentElement.scrollWidth - alertObj.offsetWidth)/2 + 'px';
  alertObj.style.visiblity='visible';

  h1 = alertObj.appendChild(d.createElement('h1'));
  h1.appendChild(d.createTextNode(title));

  msg = alertObj.appendChild(d.createElement('p'));
  //msg.appendChild(d.createTextNode(txt));
  msg.innerHTML = txt;

  container = alertObj.appendChild(d.createElement('div'));
  container.classList.add('button-container');

  if (closeButton) {
    btnClose = container.appendChild(d.createElement('a'));
    btnClose.classList.add('button');
    btnClose.classList.add('button--secondary');
    btnClose.appendChild(d.createTextNode(closeLabel));
    btnClose.href = '#';
    btnClose.focus();
    btnClose.onclick = function () {
      removeCustomAlert(); return false;
    }
  }

  if (label) {
    btn = container.appendChild(d.createElement('a'));
    btn.classList.add('button');
    btn.classList.add('button--primary');
    btn.appendChild(d.createTextNode(label));
    btn.href = '#';
    btn.focus();
    btn.onclick = function () {
      if (action) action();
      removeCustomAlert(); return false;
    }
  }

  alertObj.style.display = 'block';
}

export const initialState = {
  templateType: 'TTL',
  triggerTimelineTemplateId: 'DEFAULT',
  title: '',
  img: '',
  icon: '',
  text: '',
  linkLabel: '',
  linkUrl: '',
  priority: '',
  expiringCampaignDate: '',
  persistenceNotificationDate: '',
  buttonPrimaryLabel: '',
  buttonPrimaryOption: '',
  buttonSecondaryLabel: 'CHIUDI',
  buttonSecondaryAction: 'DL_CHIUDI',
  buttonSecondaryProductType: 'PRODUCT_TYPE_DEFAULT',
  titlePush: '',
  imagePush: '',
  iconPush: '',
  textPush: '',
  actionPush: '',
  actionPushProducyType: '',
  newTemplate: true,
  titleBanner: '',
  textBanner: '',
  closable: false,
  startCampaignDate: '',
  backgroundColor: 'GRAY',
  templateLogicType: 'DEFAULT',
  sizeBox: 'medium',
  consentC3: false,
  priorityBanner: 0,
  primaryCTAtype: 'DEFAULT',
  enabledAppNames: ['NEXIPAY'],
  bannerChannelChoiceLabel: ['NEXIPAY'],
  previewTitle: '',
  previewImg: '',
  previewText: '',
  ttlBackgroundColor: 'HORIZONTAL_GRADIENT_VIOLET'
};

// check if string contains ANY (at least one) html tags
export const checkAllHtmlTags = val => /<\/?\S[a-z]*>?/.test(val);

// check if string contains ANY (at least one) close html tags es. </p> </faketag>
const checkAllCloseTag = val => {
  const fakeCloseTag = val && val.match(/<\s*\/\s*.*>?/g);
  if (fakeCloseTag && fakeCloseTag.length > 0) return true;
}

// ONLY allow <b> </b> and <br> tags
export const allowBAndBrTagsOnly = val => {

  if(val && val.length > 0) {

    // check <br> tag allowed (due to mobile app restriction ONLY <br> tag is allowed - NOT <br/> or <br />)
    const brNotAllowed = /<br\s?\/\s?>/g;
    // check wrong <br> tag  syntax
    const wrogBrsyntax = /((<\/br\s?\/?\s?>)|((<bR\s?\/?\s?>)))/g; // es. </br> </ br> <bR>
    if(val && (val.match(brNotAllowed) || val.match(wrogBrsyntax) )) return false;

    // check wrong open b tag
    const openBTag = /<b\s?([^>]+\s?)*$/g; // es: "<b ", <b abcd, <b abcd efg, <b &!)
    if(val && val.match(openBTag)) return false;

    // olnyOpenTag check (ONLY case <b could not be managed)
    const olnyOpenTag = val && val.match(/<[a-zA-Z]+(?!>)/g);
    if (olnyOpenTag && olnyOpenTag.length > 0) {
      // filter tag !== '<b' is necessary to esclude caso of <br> tags entered
      const onlyOpenTagFiltered = olnyOpenTag.filter(tag => (tag !== '<b'))
      // console.log('onlyOpenTagFiltered', onlyOpenTagFiltered.length > 0)
      if (onlyOpenTagFiltered && onlyOpenTagFiltered.length > 0) return false;
    }

    const parser = new DOMParser();
    const doc = val && parser.parseFromString(val, 'text/html').body.getElementsByTagName('*');
    // const tagsArray = doc && [...doc].map(el=> el.outerHTML);
    const tagsArray = [...doc];

    if (tagsArray && tagsArray.length > 0 ) {
      if (tagsArray.every( (tag) => (tag.localName === 'b' || tag.localName === 'br'))) {
        // console.log('tag consentiti', tagsArray);
        // console.log('TagsArray', tagsArray)
        // check for closing tag excluded </b> (to check limit case of fake close tag such as </faketag>)
        const replacedBrTag = val && val.replace(/<\/b>/g, '');
        if (checkAllCloseTag(replacedBrTag)) return false;

        if ( tagsArray.some( (tag) => (tag.localName === 'b')) ) {
          // checks for paring open and close b tags
          const openBTags = doc && val.match(/<b>/g);
          const closedBTags = doc && val.match(/<\/b>/g);
          const numberOpenBTags = openBTags && openBTags.length;
          const numberClosedBTags = closedBTags && closedBTags.length;
          // console.log('numberOpenBTags', numberOpenBTags)
          // console.log('numberClosedBTags', numberClosedBTags)
          if (numberOpenBTags && numberOpenBTags > 0 && numberClosedBTags && numberClosedBTags > 0 && numberOpenBTags === numberClosedBTags) {
            //chech if at least one closed </b> tag is entered after the <b> open tag
            const openBLastIndex = val.lastIndexOf('<b>');
            const closedBLastIndex = val.lastIndexOf('</b>');
            // console.log('openBLastIndex', openBLastIndex)
            // console.log('closedBLastIndex', closedBLastIndex)
            if (openBLastIndex >= 0 && closedBLastIndex >= 0 && openBLastIndex < closedBLastIndex) {
              // console.log('<b> before </b>')
              return true;
            } else {
              // console.log('<b> after </b>')
              return false;
            }
          } else {
            // console.log('<b> and </b> not paring');
            return false;
          }
        } else {
          // console.log('case <br>');
          return true;
        }


      } else {
        return false;
      }
    } else {
      // case text without tags
      // console.log('case text without tags');

      // check for closing tag (to check not allowed closing tags and limit case of fake close tag such as </faketag>)
      if (checkAllCloseTag(val)) return false;
      return true;
    }
  } else {
    return true;
  }

}

export const checkValidPAR = val =>  {
  if(val && val.includes('%%')) {
  const matchedPARArray = val && val.match(/%%.*?%%/g)
  const arrayResult = matchedPARArray && matchedPARArray.every(el=> {
      return /%%PAR[1-9]0?%%/.test(el)
    })
    return !arrayResult
  } else false
}

export const disableSaveButton = (values) =>  {
  if (values.templateType && values.templateType.includes(TEMPLATE_TYPE.TTL)) {
    // TTL
    switch (values.triggerTimelineTemplateId) {
      case 'SUBSCRIBE_IOSI_PLUS':
      case 'RENEW_IOSI_PLUS':
      case 'SUBSCRIBE_IOSI_START':
      case 'RENEW_IOSI_START':
        return !values.startCampaignDate ||
                  !values.endCampaignDate || !values.persistenceNotificationDate || !values.enabledAppNames?.length;
      default:
        // 'DEFAULT'
        return !values.title || !values.text || !values.buttonSecondaryLabel || !values.startCampaignDate ||
            !values.endCampaignDate || !values.persistenceNotificationDate ||
            !values.previewTitle || !values.previewText || !values.previewImg ||
            !allowBAndBrTagsOnly(values.title) || !allowBAndBrTagsOnly(values.text) || checkValidPAR(values.text) || checkValidPAR(values.title) ||
        (values.primaryCTAtype === 'ACTION' && !/^ACTION/.test(values.buttonActionOption)) ||
        ((values.primaryCTAtype === 'DL' && !values.buttonDeeplinkingLabel) || (values.primaryCTAtype === 'ACTION' && !values.buttonActionLabel)) || !values.enabledAppNames?.length;
    }
    //
  } else if (values.templateType && values.templateType.includes(TEMPLATE_TYPE.PUSH)) {
    // PUSH
    return !values.textPush || !values.persistenceNotificationDate || checkAllHtmlTags(values.titlePush) || checkAllHtmlTags(values.textPush)
  } else {
    // BANNER
    return !values.textBanner || !values.titleBanner || checkValidPAR(values.textBanner) || checkAllHtmlTags(values.textBanner) || !values.startCampaignDate ||
            !values.endCampaignDate || !values.target || values.priorityBanner < 1 || checkAllHtmlTags(values.titleBanner) ||
              ((values.primaryCTAtype === 'DL' && !values.buttonDeeplinkingLabel) || (values.primaryCTAtype === 'ACTION' && !values.buttonActionLabel)) ||
              (values.primaryCTAtype === 'DL' && !/^DL/.test(values.buttonDeeplinkingOption)) ||
              (values.primaryCTAtype === 'ACTION' && !/^ACTION/.test(values.buttonActionOption)) ||
              (values.primaryCTAtype === 'EXT_LINK' && (values && values.linkLabel && values.linkLabel.trim() === '' || values && values.linkUrl && values.linkUrl.trim() === '')) ||
              (values && values.titleBanner && values.titleBanner.trim() === '') || (values && values.textBanner && values.textBanner.trim() === '') ||
              ((!values.bannerChannelChoiceLabel || !values.bannerChannelChoiceLabel.length));
              ;
  }
}
